import fetchAPI from "./fetchAPI"

export async function fetchPersonDetails(pin) {
  const { fetchPersonDetails } = await fetchAPI(
    `query($pin: Float!) {
        fetchPersonDetails(pin: $pin) {
          error
          firstName
          lastName
          address
          zip
          city
        }
      }`,
    {
      variables: { pin }
    },
    true
  )

  return fetchPersonDetails
}

export async function createOrder(formData) {
  const { createOrder } = await fetchAPI(
    `mutation($formData: JSON!) {
        createOrder(formData: $formData) {
          script
          redirect,
          tracking,
          data,
          orderId
          orderKey
        }
      }`,
    {
      variables: { formData }
    }
  )

  return createOrder
}

export async function getSwedbankPayOrderScript(orderKey) {
  const data = await fetchAPI(
    `query($orderKey: String!) {
        getSwedbankPayOrderScript(orderKey: $orderKey) {
          script
          orderId
        }
      }`,
    {
      variables: { orderKey }
    }
  )

  if (Array.isArray(data)) {
    return null
  }

  const payload = data?.getSwedbankPayOrderScript

  if (
    !payload ||
    typeof payload.script !== "string" ||
    payload.script === "" ||
    !Number.isFinite(Number(payload.orderId))
  ) {
    return null
  }

  return payload
}

export async function abandonSwedbankCheckout(orderKey) {
  const data = await fetchAPI(
    `mutation($orderKey: String!) {
        abandonSwedbankCheckout(orderKey: $orderKey) {
          ok
        }
      }`,
    {
      variables: { orderKey }
    }
  )

  if (Array.isArray(data)) {
    return { ok: false }
  }

  return data?.abandonSwedbankCheckout ?? { ok: false }
}

export async function completeOrder(data) {
  const { completeOrder } = await fetchAPI(
    `mutation($data: JSON!) {
        completeOrder(data: $data) {
          redirect,
          tracking,
          data
        }
      }`,
    {
      variables: { data }
    }
  )

  return completeOrder
}

export async function fetchMemorySheet(orderId, orderKey) {
  const { memorySheet } = await fetchAPI(
    `query($orderId: Int, $orderKey: String) {
        memorySheet(orderId: $orderId, orderKey: $orderKey) {
          url
        }
      }`,
    {
      variables: { orderId, orderKey }
    }
  )

  return memorySheet
}

export async function fetchOrderSummary(orderId, orderKey) {
  const { orderSummary } = await fetchAPI(
    `query($orderId: Int!, $orderKey: String!) {
        orderSummary(orderId: $orderId, orderKey: $orderKey) {
          order
        }
      }`,
    {
      variables: { orderId, orderKey }
    }
  )

  return orderSummary
}

export async function addOrderLog(orderSessionId, step, data) {
  if (
    process.env.NEXT_PUBLIC_LOG_ORDER === undefined ||
    !process.env.NEXT_PUBLIC_LOG_ORDER
  ) {
    return {
      status: false
    }
  }

  data = JSON.stringify(data)

  const { addOrderLog } = await fetchAPI(
    `mutation($orderSessionId: String!, $step: String!, $data: String!) {
        addOrderLog(orderSessionId: $orderSessionId, step: $step, data: $data) {
          status,
        }
      }`,
    {
      variables: { orderSessionId, step, data }
    }
  )

  return addOrderLog
}

export async function checkIfScriveDocumentIsSigned(documentId) {
  const data = await fetchAPI(
    `query($documentId: String!) {
      checkIfScriveDocumentIsSigned(documentId: $documentId) {
        data
      }
    }`,
    {
      variables: {
        documentId
      }
    }
  )
  return data
}

export async function requestOrderIntent({
  intent,
  formId,
  path,
  pin,
  phone,
  email,
  captcha
}) {
  const { orderIntent } = await fetchAPI(
    `mutation($intent: Boolean!, $formId: Int!, $path: String!, $pin: String!, $phone: String!, $email: String!, $captcha: String!) {
        orderIntent(intent: $intent, formId: $formId, path: $path, pin: $pin, phone: $phone, email: $email, captcha: $captcha) {
          status
        }
      }`,
    {
      variables: {
        intent,
        formId,
        path,
        pin,
        phone,
        email,
        captcha
      }
    }
  )

  return orderIntent
}
